import { z } from 'zod';

export const profileSchema = z.object({
  notificationsNews: z.nullable(z.boolean()),
  notificationsPromotions: z.nullable(z.boolean()),
  notificationsRenew: z.nullable(z.boolean()),
  name: z.string(),
  surname: z.string(),
  email: z.string(),
  additionalInfo: z.nullable(z.string()),
  city: z.nullable(z.string()),
  profilePicture: z.string().optional().nullable(),
  subscriber: z.boolean(),
  needsToUpdatePayment: z.boolean().optional().nullable(),
});

export type Profile = z.infer<typeof profileSchema>;
